import { provide as t, inject as i } from "vue";
class n {
  key;
  constructor(e) {
    this.key = e;
  }
  provideToApp(e, o) {
    o.provide(this.key, e);
  }
  provideFromComponentSetup(e) {
    t(this.key, e);
  }
  useInjection() {
    return i(this.key, void 0);
  }
}
export {
  n as OptionalInjectionFacade
};
//# sourceMappingURL=optional-injection-facade.js.map
